'use strict';

var arrayWithHoles = require('./arrayWithHoles.js');
var iterableToArrayLimit = require('./iterableToArrayLimit.js');
var nonIterableRest = require('./nonIterableRest.js');

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
